import { Box, Column, Columns, Stack } from 'braid-design-system';
import React from 'react';

import { JobCard } from '../JobCard';
import { SearchResultPlaceholder } from '../SearchResultPlaceholder';

interface Props {
  id: string;
  serpDetails: any;
}

export const SearchResultPreview = ({ id, serpDetails }: Props) => (
  <Columns space="none" collapseBelow="tablet">
    <Column width="3/4">
      <Box background="surface">
        <Stack space="xxsmall">
          <SearchResultPlaceholder lines={2} />
          <JobCard id={id} {...serpDetails} />
          <SearchResultPlaceholder />
        </Stack>
      </Box>
    </Column>
  </Columns>
);
